export default __webpack_public_path__ + "static/media/7_1692344854-min.ef134bad.jpg";